import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/carga-de-reporte-detalle/';
export const optimizedURI = '/relojchecador/carga-de-reporte-detalle-vista-optimized/';

/**
 * GET Detalles del periodo de la carga del Reporte del Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCargasReportesXlsRelojPag = async (params) => {
  try {
    const response = await API.get(optimizedURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Detalles del periodo de la carga del Reporte del Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCargasReportesXlsReloj = async (params) => {
  try {
    const response = await API.get(optimizedURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCargaReporteXlsReloj = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Detalles del periodo de la carga del Reporte del Reloj
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCargaReporteXlsReloj = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCargaReporteXlsReloj = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCargaReporteXlsReloj = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Detalles del periodo de la carga del Reporte del Reloj
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarCargaReporteXlsReloj = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
